import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  LOAN_APPLICATION_UPDATE_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
} from './../../actions/types'

const settings = (state={}, {type, payload}) => {
  switch(type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      return payload.applicationFlow.settings || state

    case LOAN_APPLICATION_UPDATE_SUCCESS:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      return payload.settings || state

    default:
      return state
  }
}

export default settings;
